import React, { useEffect, useState } from "react";
import { getRecordingBlob } from "../../services/recordingServices.js";

export default function AuthenticatedAudio({ pathRecord, ...audioProps }) {
  const [audio, setAudio] = useState({ path: null, url: "", error: false });
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl = "";
    let active = true;
    setAudio({ path: pathRecord, url: "", error: false });
    if (pathRecord) {
      getRecordingBlob(pathRecord, { signal: controller.signal }).then((blob) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setAudio({ path: pathRecord, url: objectUrl, error: false });
      }).catch(() => {
        if (active) setAudio({ path: pathRecord, url: "", error: true });
      });
    }
    return () => {
      active = false;
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [pathRecord]);
  if (!pathRecord) return <span>Aucun fichier audio disponible.</span>;
  if (audio.path !== pathRecord || (!audio.url && !audio.error)) return <span role="status">Chargement audio…</span>;
  if (audio.error) return <span role="status">Enregistrement indisponible. Vérifiez votre accès.</span>;
  return <audio {...audioProps} controls src={audio.url}>Votre navigateur ne supporte pas l'audio.</audio>;
}
